import { Skill } from './Skill';
import { SkillStatesColor, SkillStatesLabel } from './SkillState';

export interface ProgressBar {
  label: SkillStatesLabel;
  color: SkillStatesColor;
  value: number;
  className: string;
  valuePerType?: { [key: string]: number };
  skills?: Skill[];
  order?: ProgressBarOrder;
  users?: UsersInProgressBar[];
  count?: number;
  key?: string;
  studentId?: string;
  skillId?: string;
}

export interface UsersInProgressBar {
  id: string;
  firstName: string;
  lastName: string;
  publicUserId: string;
}

export enum ProgressBarOrder {
  DEMONSTRATED = 1,
  ALMOST_THERE = 2,
  REVIEW = 3,
  KEEP_LEARNING = 4,
  NOT_STARTED = 5,
}

export enum ProgressBarParent {
  SINGLE_UNIT,
  DASHBOARD,
  PROGRESS_PAGE_STUDENT_TAB,
}
